export const getPinnedHeight = (
  prev: number | undefined,
  currentHeight: number | undefined,
): number | undefined => {
  if (prev !== undefined) return prev;
  return currentHeight && currentHeight > 0 ? currentHeight : prev;
}
